import React from 'react';
import { SpinnerTW } from '../../../../tailwindComponents/spinnerTW/SpinnerTW';
import { SpinnerSize } from '../../../../ui-toolkit';

export const LoadingMessage: React.FC = () => (
  <div className="flex flex-col items-center gap-4 self-stretch bg-gray-100 p-4" data-test-id="empty-events-section">
    <SpinnerTW size={SpinnerSize.huge} />
    <span className="font-inter text-base font-normal leading-5">Loading events...</span>
  </div>
);
